import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { EducationtestdirectoryComponent } from './education-testdirectory.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpModule, JsonpModule } from '@angular/http';

const routes: Routes = [{
	path: '',
	data: {
      title: 'Education: Class Directory',
      urls: [{title: 'Dashboard',url: '/'},{title: 'Education: Class Directory'}]
    },
	component: EducationtestdirectoryComponent
}];

@NgModule({
	imports: [
    	FormsModule,
    	CommonModule,
		HttpModule,
        JsonpModule,
        NgbModule.forRoot(),
    	RouterModule.forChild(routes)
    ],
	declarations: [EducationtestdirectoryComponent]
})
export class EducationtestdirectoryModule { }


// WEBPACK FOOTER //
// /Users/sheashay/Sites/ihsaa-ams-design/src/app/pages/education/education-testdirectory/education-testdirectory.module.ts